import { useState } from "react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Eraser, ArrowLeftRight, Undo2 } from "lucide-react";
import { normalizeTranscript } from "../lib/plaudCleanup";

const PLACEHOLDER = "Collez ici la transcription complète de la séance…\n\nExemple :\nThérapeute : Comment s'est passée votre semaine ?\nPatient : ...";

export const TranscriptEditor = ({ value, onChange, disabled = false, rows = 12, testId = "transcript" }) => {
  const [cleanup, setCleanup] = useState(null);
  const chars = (value || "").trim().length;

  const runCleanup = (swap) => {
    const original = cleanup?.original ?? value;
    const res = normalizeTranscript(original, { swap });
    if (!res.turns) { toast.error("Aucune intervention reconnue dans le texte collé"); return; }
    onChange(res.text);
    setCleanup({ original, swap, speakers: res.speakers, turns: res.turns });
    if (!cleanup) toast.success(`${res.turns} interventions normalisées au format Kintsugi`);
  };

  const undo = () => { onChange(cleanup.original); setCleanup(null); };
  const handleChange = (v) => { if (cleanup) setCleanup(null); onChange(v); };

  return (
    <div className="space-y-2">
      <textarea
        value={value || ""}
        onChange={(e) => handleChange(e.target.value)}
        rows={rows}
        disabled={disabled}
        placeholder={PLACEHOLDER}
        className="w-full px-3 py-2 text-sm font-mono border rounded-lg bg-background border-border disabled:opacity-60"
        data-testid={`${testId}-textarea`}
      />
      <div className="flex items-center gap-2 flex-wrap" data-testid={`${testId}-cleanup-toolbar`}>
        {!cleanup ? (
          <Button variant="outline" size="sm" onClick={() => runCleanup(false)} disabled={disabled || chars === 0} data-testid={`${testId}-cleanup-btn`}>
            <Eraser className="w-3.5 h-3.5 mr-1.5" /> Nettoyer (format Plaud → Kintsugi)
          </Button>
        ) : (
          <>
            <span className="text-xs text-muted-foreground" data-testid={`${testId}-cleanup-summary`}>
              {cleanup.turns} interventions · {cleanup.speakers.map((s) => `${s.from} → ${s.to}`).join(" · ") || "sans locuteur"}
            </span>
            <Button variant="outline" size="sm" onClick={() => runCleanup(!cleanup.swap)} disabled={disabled || cleanup.speakers.length < 2} data-testid={`${testId}-cleanup-swap-btn`}>
              <ArrowLeftRight className="w-3.5 h-3.5 mr-1.5" /> Inverser Thérapeute / Patient
            </Button>
            <Button variant="ghost" size="sm" onClick={undo} disabled={disabled} data-testid={`${testId}-cleanup-undo-btn`}>
              <Undo2 className="w-3.5 h-3.5 mr-1.5" /> Annuler le nettoyage
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
